var PaymentHandler = {

	'getPaymentData': function(AskFormStorage) {
		return {
			'paymentMethodId': AskFormStorage.get('selectedPaymentMethodId'),
			'paymentProviderId': AskFormStorage.get('selectedPaymentProviderId'),
			'voucherCode': AskFormStorage.get('voucherCode')
		};
	},

	'handlePayment': function($scope, AskFormStorage, result) {
		$scope.status.paymentStatusId = result.statusId;
		if (result.statusId === $scope.paymentStatus.payment_in_progress && $scope.status.step !== 'authorizationRequestSent' && result.paymentMethodId === $scope.paymentMethod.partnerEmail) {
			$scope.status.doVerification = false;
			$scope.status.step = 'authorizationForm';
			$scope.validateAuthorizationForm();
		} else if (result.statusId === $scope.paymentStatus.payment_created || result.statusId === $scope.paymentStatus.payment_in_progress) {
			var timeDiff = moment().unix() - moment(result.dateCreate.date).unix();
			$scope.status.waitingTimeExpired = (timeDiff > 30);
		} else if (result.statusId === $scope.paymentStatus.payment_confirmed) {
			$scope.status.doVerification = false;
			$scope.status.step = 'done';
			AskFormStorage.clearAll();
			//$.scrollTo('#summary-table', 200);
		} else {
			if (result.paymentMethodId === $scope.paymentMethod.voucher) {
				$scope.status.step = 'selectPaymentMethod';
				$scope.validation.voucherError = true;
			} else if (result.paymentMethodId === $scope.paymentMethod.partnerEmail) {
				$scope.status.step = 'authorizationRequestError';
			} else {
				$scope.status.step = 'paymentError';
			}
			//$.scrollTo('#summary-table', 200);
		}
	}
};
